module.exports = __webpack_public_path__ + "assets/img/icon6.0c6e0e97.png";